
export const products = {
  'product.categories': 'Product Categories',
  'explore.solutions': 'Explore our comprehensive range of professional AV solutions',
  'view.video': 'View Product Overview Video',
  // Product categories
  'AV Over IP': 'AV Over IP',
  'ReAX Control': 'ReAX Control',
  'Meeting Room Solutions': 'Meeting Room Solutions',
  'Converters/Scalers': 'Converters/Scalers',
  'Audio Products': 'Audio Products',
  'HDMI Switchers': 'HDMI Switchers',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'HDBaseT Products',
  // Product descriptions
  'Complete AV distribution solution with ultra-low latency': 'Complete AV distribution solution with ultra-low latency',
  'Professional control system solutions': 'Professional control system solutions',
  'Complete solutions for modern meeting spaces': 'Complete solutions for modern meeting spaces',
  'Professional format conversion and scaling solutions': 'Professional format conversion and scaling solutions',
  'Professional audio processing and playback solutions': 'Professional audio processing and playback solutions',
  'Professional HDMI switching and distribution solutions': 'Professional HDMI switching and distribution solutions',
  'Advanced IP-based AV distribution platform': 'Advanced IP-based AV distribution platform',
  'Professional HDBaseT distribution solutions': 'Professional HDBaseT distribution solutions',
  // Group-related translations
  'group.not.found': 'Group not found',
  'back.to.avoip': 'Back to AVOIP options',
  'back.to.reax': 'Back to ReAX Control options',
  'back.to.audio': 'Back to Audio options',
  'back.to.categories': 'Back to categories',
  // Product detail page translations
  'product.not.found': 'Product not found',
  'return.to.home': 'Return to home',
  'back.to.product.group': 'Back to product group',
  'overview': 'Overview',
  'full.description': 'Full Description',
  'features': 'Features',
  'specifications': 'Specifications',
};
